import {AbstractReactComponent, i18n} from 'mc/lib';
import {ModalActions} from 'mc/lib/modal';
import React from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {browserHistory} from 'react-router';
import {Button, Card, Col, Navbar, NavbarBrand, Row} from 'reactstrap';
import {Api} from '../api';
import {LoginForm, PasswordRecoveryForm, RegisterForm} from '../components';
import {getQueryParams} from '../utils';
import './LoginPage.scss';
import * as UserActions from "../actions/userActions";

class LoginPage extends AbstractReactComponent {

    constructor(props) {
        super(props);
        this.state = {openidConfigured: true};
    }

    componentDidMount() {
        this.setState({queryParams: getQueryParams()});
        Api.isOpenIdConfigured().then((configured) => configured.text().then(message => {
            let configured = message === "true";
            this.setState({
                 openidConfigured: configured
            });
            if (configured) {
                Api.loginByOpenId();
            }
        }));
    }


    onLogin = () => {
        const {queryParams} = this.state;
        if (queryParams.idTypZabor != null) {
            return Api.createZadost(queryParams.idTypZabor).then(res => {
                browserHistory.push(serverContextPath + '/zadost/' + res.id + '/nalezitosti');
            });
        } else {
            browserHistory.push(serverContextPath);
        }
    };

    showRegisterModal = () => {
        const {queryParams} = this.state;
        this.dispatch(ModalActions.show(RegisterForm, {
            idTypZabor: queryParams.idTypZabor,
            onRegister: () => {
                this.dispatch(ModalActions.hide());
                toastr.info(i18n('toastr.registerDone'));
            }
        }, i18n('modal.passRecovery')))
    };

    showPassRecoveryModal = () => {
        this.dispatch(ModalActions.show(PasswordRecoveryForm, {onComplete: () => {
            this.dispatch(ModalActions.hide());
            toastr.info(i18n('toastr.recoveryPass'));
        }}, i18n('modal.register')))
    };

    rootPage = () => {
        browserHistory.push(serverContextPath);
    };

    render() {
        const queryParams = this.state.queryParams;
        const openidConfigured = this.state.openidConfigured;

        return <Row>
            <Col xs={12}>
                <Row>
                    <Navbar id="header" inverse fixed="top">
                        <NavbarBrand href="javascript:void(0)" onClick={this.rootPage}>
                            {window.APP_TITLE}
                        </NavbarBrand>
                    </Navbar>
                </Row>
                <Row className="login-page">
                    <Col xs={12} md={{size: 10, offset: 1}} xl={{size: 8, offset: 2}}>
                        {openidConfigured ?
                            <Card block>
                                <p>Přesněrování na přihlášení.</p>
                            </Card>
                            :
                            <div>
                                {queryParams && queryParams.idTypZabor != null && (
                                    <Card block>
                                        <p>Žádosti mohou v systému vytvářet jen registrovaní uživatelé.
                                            Před pokračováním se prosím přihlašte nebo se zaregistrujte.
                                            Pokud se zargistrujete, odbržíte do emailové schránky odkaz,
                                            kterým registraci potvrdíte a zároveň můžete ihned pokračovat
                                            v tvorbě žádosti vybraného typu.</p>
                                    </Card>
                                )}
                                <Card block>
                                    <Row>
                                        <Col xs={12} sm={12} md={{size: 4, offset: 1}} className="mb-4 mb-md-0">
                                            <div className="form-box">
                                                <LoginForm onLogin={this.onLogin} onLostPassword={this.showPassRecoveryModal} />
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={{size: 5, offset: 1}}>
                                            <h3>{i18n('registerBox.title')}</h3>
                                            <p>{i18n('registerBox.info.title')}</p>
                                            <ul>
                                                <li>{i18n('registerBox.info.line1')}</li>
                                                <li>{i18n('registerBox.info.line2')}</li>
                                                <li>{i18n('registerBox.info.line3')}</li>
                                            </ul>
                                            <Button color="primary" block onClick={this.showRegisterModal}>{i18n('registerBox.createAcc')}</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </div>
                        }
                    </Col>
                </Row>
            </Col>
        </Row>
    }
}

export default connect()(LoginPage);
